import { GenericFormError } from 'dg-web-shared/common/utils/FormHooksUtils.tsx';
import {
    RequestStatus,
    ServerRequestState,
} from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import { ErrorAlert } from 'dg-web-shared/common/components/material-ui/ErrorAlert.tsx';

export function GenericFormSubmitError({
    error,
    submitState,
}: {
    error: GenericFormError | null;
    submitState: ServerRequestState<unknown, unknown>;
}) {
    if (!error) {
        return null;
    }

    const alertSpacing = {
        marginY: 2,
    };

    if (error.isGenericServerError) {
        return (
            <ErrorAlert sx={alertSpacing}>
                <>
                    <Localized
                        de="The request returned an error: status "
                        fr="The request returned an error: status "
                        it="The request returned an error: status "
                        en="The request returned an error: status "
                    />
                    {submitState?.status === RequestStatus.ERROR &&
                        submitState.httpStatusCode}
                </>
            </ErrorAlert>
        );
    }

    return (
        <>
            {error.issues.map(e => (
                <ErrorAlert key={e.issue.message} sx={alertSpacing}>
                    <Localized {...e.issue.humanReadableMessage.byLanguage} />
                </ErrorAlert>
            ))}
        </>
    );
}
